"use client";

import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { observatoryCountAtom } from "@/store/home";

function HomeStatObservatory(): ReactElement | null {
  const t = useTranslations("home.StatObservatory");
  const count = useAtomValue(observatoryCountAtom);

  if (!count) return null;

  return (
    <div className="p-0 flex flex-row gap-2">
      <span className="font-mono text-3xl text-yellow-100">{count}</span>
      <span className="text-sm text-yellow-300">
        {t("label", { count: count })}
      </span>
    </div>
  );
}

export { HomeStatObservatory };
